import { Image, useModal } from '@pelando/components';
import { useCallback } from 'react';
import { useTranslation } from '@/presentation/hooks/useTranslation';
import { ReactionType, Reactions } from '../../../domain/entities/Comment';
import {
  Container,
  Reaction,
  ReactionModalStyle,
  WrapperImage,
} from './styles';

function ReactionItem({
  counter,
  type,
}: {
  counter: number;
  type: ReactionType;
}) {
  const { t } = useTranslation('deal');
  const imageAndAltByReactionType = (type: ReactionType) =>
    ({
      [ReactionType.FUNNY]: {
        image: '/assets/reacoes/haha.svg',
        alt: t('reaction-item-funny'),
      },
      [ReactionType.LIKE]: {
        image: '/assets/reacoes/like.svg',
        alt: t('reaction-item-like'),
      },
      [ReactionType.HELPFUL]: {
        image: '/assets/reacoes/helpful.svg',
        alt: t('reaction-item-helpful'),
      },
    }[type]);
  if (!counter) return null;
  const { alt, image } = imageAndAltByReactionType(type);
  return (
    <Reaction>
      <WrapperImage>
        <Image src={image} alt={alt} />
      </WrapperImage>
      {counter}
    </Reaction>
  );
}

export function ReactionsModal({ funny, helpful, like }: Reactions) {
  return (
    <Container>
      <ReactionItem counter={like} type={ReactionType.LIKE} />
      <ReactionItem counter={funny} type={ReactionType.FUNNY} />
      <ReactionItem counter={helpful} type={ReactionType.HELPFUL} />
    </Container>
  );
}

export const sumReactions = ({ funny, helpful, like }: Reactions) =>
  funny + helpful + like;

export function useReactionsModal() {
  const { t } = useTranslation('deal');
  const { showModal } = useModal();

  return useCallback(
    (props: Reactions) =>
      showModal(<ReactionsModal {...props} />, {
        title: `${sumReactions(props)} ${t('reactions-modal-title')}`,
        style: ReactionModalStyle,
      }),
    [showModal, t]
  );
}
